<form class="contract-access" [formGroup]="accessRequestForm" (ngSubmit)="getAccessRequest()">
    <div class="contract-access__header">
        <div class="contract-access__header-icon">
            <i class="fal fa-file-contract"></i>
        </div>
        <h2 class="contract-access__title"> {{ 'ASK_ACCESS_NEW_CONTRACT' | translate }} </h2>
        <button type="button" class="btn btn-icon btn-sm btn-active-light contract-access__close" mat-dialog-close [attr.aria-label]="'CLOSE' | translate">
            <i class="fal fa-xmark fs-3"></i>
        </button>
    </div>

    <div class="contract-access__body">
        <div class="row g-4">
            <div class="col-12">
                <label class="contract-access__label" for="email">
                    {{ 'CLIENT_EMAIL' | translate }}
                    <i class="fal fa-circle-info info-icon"
                        [matTooltip]="('CONTACT_EMAIL_INFO' | translate)"
                        matTooltipPosition="right"></i>
                </label>
                <input id="email" class="form-control form-control-solid" formControlName="email" type="email" autocomplete="email">
            </div>

            <div class="col-12 col-md-6">
                <label class="contract-access__label" for="tin">
                    {{ 'CLIENT_TIN' | translate }}
                    <i class="fal fa-circle-info info-icon"
                        [matTooltip]="('ENTITY_TIN_INFO' | translate)"
                        matTooltipPosition="right"></i>
                </label>
                <input id="tin" class="form-control form-control-solid" formControlName="tin" type="text" maxlength="9" inputmode="numeric">
            </div>

            <div class="col-12 col-md-6">
                <label class="contract-access__label" for="phone">
                    {{ 'CLIENT_CELLPHONE' | translate }}
                    <i class="fal fa-circle-info info-icon"
                        [matTooltip]="('CONTACT_MOBILE_PHONE_NUMBER_INFO' | translate)"
                        matTooltipPosition="right"></i>
                </label>
                <input #phone class="form-control form-control-solid w-100" id="phone" formControlName="contactNumber" type="tel">
            </div>
        </div>

        <div class="contract-access__notice">
            <i class="fal fa-circle-info contract-access__notice-icon"></i>
            <div>
                <div class="text-gray-800"> {{ 'INSERT_CONTRACT_DATA_INSTRUCTIONS' | translate }} </div>
                <div class="text-muted fs-7 mt-2"> {{ 'INSERT_CONTRACT_DATA_INSTRUCTIONS_SUBTITLE' | translate }} </div>
            </div>
        </div>
    </div>

    <div class="contract-access__footer">
        <button type="button" class="btn btn-light" mat-dialog-close> {{ 'CANCEL' | translate }} </button>
        <button type="submit" class="btn finish-button">
            {{ 'REQUEST_ACCESS' | translate }}
            <i class="fa-solid fa-arrow-right ms-2"></i>
        </button>
    </div>
</form>
